module.exports = __webpack_public_path__ + "img/11.ecceb453.jpg";